import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import insurancesApi from '@/features/dashboard/insurances/api/insurancesApi.ts';
import { insurancesApiQueryKeys } from '@/features/dashboard/insurances/api/insurancesApi.queryKeys.ts';
import { InsuranceWebDto } from '@/features/dashboard/insurances/types/InsuranceWebDto.ts';

export const getInsuranceQueryOptions = (
  id: string,
): UseQueryOptions<InsuranceWebDto> => ({
  queryKey: insurancesApiQueryKeys.byId(id),
  queryFn: () => insurancesApi.get(id),
  enabled: id !== undefined,
});

const useGetInsurance = (id: string) => {
  return useQuery(getInsuranceQueryOptions(id));
};

export default useGetInsurance;
